/**
 * @description
 * 他のファンクラブアプリからルート認証を行った際の認証情報をストレージに保存する機構
 * 認証サーバからのリダイレクトでアプリに飛んだ際のクエリパラメータ検証し、セットする
 *
 * このフック自体は 抽選詳細ページ LotteryDetail で利用する
 *
 * https://app.clickup.com/t/908127/UT-15166
 */

import { useEffect, useState } from 'react'

import { getPrefrenceObject, setPreference } from '../native/storage'
import { useRouter } from '../router'

export const useRootAuth = () => {
  const { router } =
    useRouter<{ preSaleId?: string; clientId?: string; token?: string }>()
  const [rootAuthInfo, setRootAuthInfo] = useState<{
    clientId?: string
    token?: string
    preSaleId?: string
  }>({})

  // クエリパラメータをlocalStorageに保存
  useEffect(() => {
    if (router.query.preSaleId && router.query.clientId && router.query.token) {
      setPreference('rootAuthInfo', {
        preSaleId: router.query.preSaleId,
        clientId: router.query.clientId,
        token: router.query.token,
      })
    }
  }, [router.query.clientId, router.query.token, router.query.preSaleId])

  useEffect(() => {
    ;(async () => {
      const rootAuthInfo = await getPrefrenceObject<{
        preSaleId: string
        clientId?: string
        token?: string
      }>('rootAuthInfo')

      setRootAuthInfo(rootAuthInfo)
    })()
  }, [router.pathname])

  return rootAuthInfo
}
